{
  "pt": {
    "partner": {
      "actions": {
        "add": "Adicionar",
        "changeProfilePicture": "Alterar a imagem do perfil",
        "new": "Parceiro",
        "profilePictureFormat": "Deve ter pelo menos 300x300px",
        "save": "Guardar",
        "sendinvitation": "Enviar convite",
        "submit": "Guardar",
        "undoChanges": "Anular"
      },
      "attributes": {
        "email_address": "Correio eletrónico",
        "email_notifications_interval": {
          "daily": "Uma vez por dia (por volta do meio-dia)",
          "hourly": "Cada hora",
          "twice_daily": "Duas vezes por dia (manhã/tarde)",
          "weekly": "Uma vez por semana (segunda-feira ao meio-dia)"
        },
        "first_name": "Nome próprio",
        "internal_note": "Nota interna",
        "language": "Língua",
        "last_name": "Apelido",
        "phone_landline": "Número de telefone fixo",
        "phone_mobile": "Número de telemóvel",
        "profession": "Título do emprego",
        "session_ended_at": "Último ativo em",
        "status": "Estado",
        "title": "Título"
      },
      "labels": {
        "addExistingCompany": "Adicionar a uma empresa existente",
        "contactDetails": "Dados de contacto",
        "createNewCompany": "Criar uma nova empresa",
        "information": "Informações sobre o perfil",
        "newTeamMember": "Novo parceiro",
        "notEditable": "Alguns campos de entrada já não são editáveis quando um parceiro está ativo",
        "partnerAddedState": "<b>Ainda não foi convidado</b>. Será enviado um convite por correio eletrónico quando {partner_name} tiver acesso a uma decisão, questão ou documento publicado.",
        "selectedCompany": "Empresa selecionada",
        "start_by_selecting_project": "Comece por selecionar um projeto à esquerda"
      },
      "toasts": {
        "create": "Parceiro criado",
        "update": "Parceiro atualizado"
      },
      "validation": {
        "mustBeEmailAddress": "É necessário um endereço de correio eletrónico válido",
        "needFirstName": "Nome próprio obrigatório",
        "needLastName": "Apelido obrigatório",
        "requireEmailAddress": "Correio eletrónico necessário"
      }
    }
  }
}
